"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuSplitGroup_unstable", {
    enumerable: true,
    get: ()=>useMenuSplitGroup_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _reactTabster = require("@fluentui/react-tabster");
const _reactSharedContexts = require("@fluentui/react-shared-contexts");
const _keyboardKeys = require("@fluentui/keyboard-keys");
const useMenuSplitGroup_unstable = (props, ref)=>{
    const innerRef = _react.useRef();
    const { dir , targetDocument  } = (0, _reactSharedContexts.useFluent_unstable)();
    const nextArrowKey = (0, _reactUtilities.getRTLSafeKey)(_keyboardKeys.ArrowRight, dir);
    const prevArrowKey = (0, _reactUtilities.getRTLSafeKey)(_keyboardKeys.ArrowLeft, dir);
    const { findNextFocusable , findPrevFocusable  } = (0, _reactTabster.useFocusFinders)();
    const onKeyDown = _react.useCallback((e)=>{
        var _innerRef_current;
        const activeElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.activeElement;
        if (!activeElement) {
            return;
        }
        if (!((_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.contains(activeElement))) {
            return;
        }
        if (e.key === nextArrowKey) {
            const next = findNextFocusable(activeElement, {
                container: innerRef.current
            });
            next === null || next === void 0 ? void 0 : next.focus();
        }
        if (e.key === prevArrowKey) {
            const prev = findPrevFocusable(activeElement, {
                container: innerRef.current
            });
            prev === null || prev === void 0 ? void 0 : prev.focus();
        }
    }, [
        findNextFocusable,
        findPrevFocusable,
        targetDocument,
        nextArrowKey,
        prevArrowKey
    ]);
    return {
        components: {
            root: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            role: 'group',
            ref: (0, _reactUtilities.useMergedRefs)(ref, innerRef),
            onKeyDown,
            ...props
        })
    };
}; //# sourceMappingURL=useMenuSplitGroup.js.map

//# sourceMappingURL=useMenuSplitGroup.js.map